import React, { FC } from 'react';
import { Provider } from 'react-redux';
import { LangContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { setupStore } from '../store/configureStore';
import BuildingMapComponent from '../components/BuildingMapComponent';

const store = setupStore();

const AppWrapperComponent: FC = () => (
  <LangContext.Provider value={window.appLang}>
    <Provider store={store}>
      <BuildingMapComponent token={window.token} />
    </Provider>
  </LangContext.Provider>
);

AppWrapperComponent.displayName = 'AppWrapperComponent';
export default AppWrapperComponent;
